import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  gap: 15,
}));

export const RulesAccordion = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  padding: 15,
  border: "1px solid rgba(37, 99, 235, 0.3)",
  borderRadius: 8,
}));

export const RulesAccordionTitle = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterBetween,
  fontWeight: 600,
}));

export const RulesAccordionToggleButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  fontSize: 24,
  border: "none",
  backgroundColor: "transparent",
  cursor: "pointer",

  "&.active > svg": {
    lineHeight: 1,
    transform: "rotate(180deg)",
  },
}));

export const RulesAccordionContent = styled("div")(({ theme }) => ({
  marginTop: 20,
}));

export const SelectRoutes = styled.div`
`;

export const StyledPaper = styled.div`
  padding: 0 16px;
  max-height: 600px;
  background-color: rgba(37, 99, 235, 0.04);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .15);
  padding: 15px;
  overflow: auto;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 3px #dfe5ec;
  }

  ::-webkit-scrollbar-thumb {
    background: #2563EB;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #2563EB;
  }
`;
export const RulesToolbar = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  justifyContent: "flex-end",
}));

export const CopyRulesButton = styled("button")(({ theme, $isCopied }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 6,
  padding: "7px 14px",
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
  cursor: "pointer",
  borderRadius: 6,
  transition: "all .2s ease-out",
  backgroundColor: $isCopied ? theme.palette.success.bg : theme.palette.white,
  color: $isCopied ? theme.palette.success.dark : theme.palette.primary.main,
  border: `1px solid ${$isCopied ? theme.palette.success.dark : theme.palette.primary.main}`,

  "& > svg": {
    fontSize: 16,
  },

  "&:hover": {
    backgroundColor: $isCopied ? theme.palette.success.bg : theme.palette.primary.bgLight,
  },

  "&:disabled": {
    cursor: "not-allowed",
    color: theme.palette.text.muted,
    borderColor: theme.palette.border.darker,
    backgroundColor: theme.palette.white,
  },
}));
